export interface ProcessoDaHora {
  proc_reg?: string | null;
  proc_autor?: string | null;
  proc_reu?: string | null;
}

export const ROTULO_DETALHE = '- Descrição: ';

export const montarDescricaoDoProcesso = (
  processo: ProcessoDaHora,
  origem: string,
): string =>
  [
    `- Autos: ${processo.proc_reg ?? ''}`,
    `- Autor(es): ${processo.proc_autor ?? ''}`,
    `- Réu(s): ${processo.proc_reu ?? ''}`,
    `- Origem: ${origem}`,
    ROTULO_DETALHE,
  ].join('\n');

export const descricaoSemDetalhe = (texto: string): boolean => {
  const limpo = texto.trim().toLocaleLowerCase();
  return limpo.length === 0 || limpo.endsWith('descrição:');
};

export const minutosDeHHMM = (valor: string): number => {
  const [h = '', m = ''] = valor.split(':');
  const horas = parseInt(h, 10);
  const minutos = parseInt(m, 10);
  if (Number.isNaN(horas) || Number.isNaN(minutos) || minutos > 59) return 0;
  return horas * 60 + minutos;
};

const pad2 = (n: number) => String(n).padStart(2, '0');

export const hhmmDeMinutos = (total: number): string =>
  `${pad2(Math.floor(total / 60))}:${pad2(total % 60)}`;

export const hhmmDoCronometro = (segundos: number): string => {
  if (segundos <= 0) return '00:00';
  return hhmmDeMinutos(Math.max(1, Math.round(segundos / 60)));
};

export const detalheDaDescricao = (texto: string): string => {
  const marca = texto.toLocaleLowerCase().lastIndexOf('descrição:');
  if (marca < 0) return texto.trim();
  const detalhe = texto.slice(marca + 'descrição:'.length).trim();
  return detalhe || texto.trim();
};
